import { combineEpics } from 'redux-observable'
import announcementsPolling$ from './announcementsPolling'
import announcementsStatePolling$ from './announcementsStatePolling'
import playInList$ from './playInList'
import votesPolling$ from './votesPolling'
import extendUserSession$ from './extendUserSession'

export default combineEpics(
  announcementsPolling$,
  announcementsStatePolling$,
  playInList$,
  votesPolling$,
  extendUserSession$
)
